/** The amenities and accessibility options for a service */
import type { FilterIds } from '../../../types/FilterIds'
import type { FilterGroupObject } from './FilterDefinition'
import type { PickUnion } from '../../../types/PickUnion'

export type ServiceFilterAmenitiesAndAccessibilityOptions = PickUnion<
  FilterIds,
  | 'amenities:wheelchair-access'
  | 'amenities:free-parking'
  | 'amenities:parking'
  | 'amenities:toilets'
  | 'amenities:visual-aids'
  | 'amenities:hearing-and-auditory-aids'
  | 'amenities:text-relay'
  | 'amenities:bsl'
  | 'amenities:language-options'
  | 'amenities:accessible-website'
>

export const amenitiesAndAccessibilityOptions: ServiceFilterAmenitiesAndAccessibilityOptions[] = [
  'amenities:wheelchair-access',
  'amenities:free-parking',
  'amenities:parking',
  'amenities:toilets',
  'amenities:visual-aids',
  'amenities:hearing-and-auditory-aids',
  'amenities:text-relay',
  'amenities:bsl',
  'amenities:language-options',
  'amenities:accessible-website'
] as const

type AmentitiesAndAccessibilityType = FilterGroupObject<ServiceFilterAmenitiesAndAccessibilityOptions>

export const generateServiceAmenitiesObjects = (): AmentitiesAndAccessibilityType => ({
  'amenities:wheelchair-access': {
    selected: false,
    label: 'Wheelchair access',
    key: 'amenities:wheelchair-access',
    filterId: 'amenities:wheelchair-access',
    serviceFilterKey: 'offersWheelChairAccess'
  },
  'amenities:free-parking': {
    selected: false,
    label: 'Free parking',
    key: 'amenities:free-parking',
    filterId: 'amenities:free-parking',
    serviceFilterKey: 'hasFreeParkingFacilities'
  },
  'amenities:parking': {
    selected: false,
    label: 'Parking',
    key: 'amenities:parking',
    filterId: 'amenities:parking',
    serviceFilterKey: 'hasParkingFacilities'
  },
  'amenities:toilets': {
    selected: false,
    label: 'Toilets',
    key: 'amenities:toilets',
    filterId: 'amenities:toilets',
    serviceFilterKey: 'hasToilets'
  },
  'amenities:visual-aids': {
    selected: false,
    label: 'Visual aids',
    key: 'amenities:visual-aids',
    filterId: 'amenities:visual-aids',
    serviceFilterKey: 'hasVisualAids'
  },
  'amenities:hearing-and-auditory-aids': {
    selected: false,
    label: 'Hearing and auditory aids',
    key: 'amenities:hearing-and-auditory-aids',
    filterId: 'amenities:hearing-and-auditory-aids',
    serviceFilterKey: 'hasHearingAndAuditoryAids'
  },
  'amenities:text-relay': {
    selected: false,
    label: 'Text relay',
    key: 'amenities:text-relay',
    filterId: 'amenities:text-relay',
    serviceFilterKey: 'hasTextRelay'
  },
  'amenities:bsl': {
    selected: false,
    label: 'BSL (British Sign Language)',
    key: 'amenities:bsl',
    filterId: 'amenities:bsl',
    serviceFilterKey: 'hasBSL'
  },
  'amenities:language-options': {
    selected: false,
    label: 'Language options',
    key: 'amenities:language-options',
    filterId: 'amenities:language-options',
    serviceFilterKey: 'offersLanguageOptions'
  },
  'amenities:accessible-website': {
    selected: false,
    label: 'Accessible website',
    key: 'amenities:accessible-website',
    filterId: 'amenities:accessible-website',
    serviceFilterKey: 'hasAccessibleWebsite'
  }
})
